// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import numbro from "numbro"
import Vue from "vue"
import * as commonController from "../controllers/commonController"
import i18n from "./i18n"

const mainForm = {
  type_name: "",
  url: "",
  url_name: "",
  order_code: "",
  customer_name: "",
  order_pool: "",
  order_amount: "",
  currency: "",
  exch_rate: "",
  tax_group: "",
  credit_amount: "",
  credit_amount_dis: "",
  order_description: "",
  username: "",
  create_at: ""
}

const itemForm = {
  lineNum: "",
  itemId: "",
  inventName: "",
  VariantName: "",
  qty: "",
  order_price: "",
  dic_price: "",
  currencyCode: "",
  so_decription: ""
}
const vm = new Vue({ i18n })
const methods = {
  getUserLangCode(vm, username) {
    let user = _.find(vm.$store.state.biz_data.userInfo.allUsers, { username: username })
    if (user) {
      return user.language_code
    }
    return "zh-CN"
  },
  ///销售订单
  getOrderEmailTemplate(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border='1' cellpadding='10' text-align='center' cellspacing='0'  style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=3 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=5 style = 'text-align:center'> " + email_template.approve_url + "：<a href='" +
      _params.main.url +
      "' rel='noopener' target='_blank'>" +
      _params.main.url_name +
      "</a></td></tr>"
    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_num + " </td><td> " +
      _params.main.order_code +
      " </td><td> " + email_template.customer_name + " </td><td colspan=3> " +
      _params.main.customer_name +
      " </td><td> " + email_template.order_pool + " </td><td> " +
      _params.main.order_pool +
      " </td></tr>"

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_amount + " </td><td> " +
      _params.main.order_amount +
      " </td><td> " + email_template.currency + " </td><td> " +
      _params.main.currency +
      " </td><td> " + email_template.exch_rate + " </td><td> " +
      _params.main.exch_rate +
      " </td><td> " + email_template.tax_group + " </td><td> " +
      _params.main.tax_group +
      " </td></tr>"

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.customer_credit + " </td><td> " +
      _params.main.credit_amount +
      " </td><td> " + email_template.valid_credit + " </td><td>" +
      _params.main.credit_amount_dis +
      "</td><td> " + email_template.order_remark + " </td><td colspan=3 style='text-align:left'> " +
      _params.main.order_description +
      " </td></tr>"

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=4>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td><td colspan=4> " + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr>"

    content += "</table>"
    return sub_content + content
  },

  ///价格不一致
  getPriceDiffTemplate(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border=1 cellpadding=10 text-align='center' cellspacing=0  style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=4 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=8 style='text-align:center'>" + email_template.approve_url + "：<a href='" +
      _params.main.url +
      "' rel='noopener' target='_blank'>" +
      _params.main.url_name +
      "</a></td></tr>"

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_num + " </td><td style='font-family:宋体;font-size:14;text-align:left'> " +
      _params.main.order_code +
      " </td><td> " + email_template.customer_name + " </td><td colspan=5 style='font-family:宋体;font-size:14;text-align:left'> " +
      _params.main.customer_name +
      " </td><td> " + email_template.order_pool + " </td><td style='font-family:宋体;font-size:14;text-align:left'> " +
      _params.main.order_pool +
      " </td><td> " + email_template.order_amount + " </td><td style='font-family:黑体;font-size:14;text-align:center'> " +
      _params.main.order_amount +
      " </td></tr>"

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.line_num + " </td><td> " +
      email_template.invent_num + " </td><td colspan=2> " + email_template.invent_name + " </td><td colspan=2> " +
      email_template.transmutation_name + " </td><td> " + email_template.qty + " </td><td> " +
      email_template.order_price + " </td><td> " + email_template.dic_price + " </td><td> " + email_template.currency +
      " </td><td colspan=2> " + email_template.order_remark + " </td></tr>"

    let item = ""
    _.each(_params.items, t => {
      item +=
        "<tr style='font-family:仿宋;font-size:14;text-align:center'>" +
        "<td> " +
        t.lineNum +
        " </td>" +
        "<td> " +
        t.itemId +
        " </td>" +
        "<td colspan=2 style = 'text-align:left'> " +
        t.inventName +
        " </td>" +
        "<td colspan=2 style = 'text-align:left'> " +
        t.VariantName +
        " </td>" +
        "<td> " +
        t.qty +
        " </td>" +
        "<td> " +
        t.order_price +
        " </td>" +
        "<td> " +
        t.dic_price +
        " </td>" +
        "<td> " +
        t.currencyCode +
        " </td>" +
        "<td colspan=2 style = 'text-align:left'> " +
        t.so_decription +
        " </td>" +
        "</tr>"
    })

    let foot =
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=6>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td><td colspan=6> " + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr></table>"

    return sub_content + content + item + foot
  },

  ///销售派发申请模板
  getSalesOrderTemplate(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=3 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=5 style='text-align:center'>" + email_template.approve_url + "：<a href='" +
      _params.main.url +
      "' rel='noopener' target='_blank'>" +
      _params.main.url_name +
      "</a></td></tr>"
    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_num + " </td><td> " +
      _params.main.order_code +
      " </td><td> " + email_template.customer_name + " </td><td colspan=3> " +
      _params.main.customer_name +
      " </td><td> " + email_template.order_pool + " </td><td> " +
      _params.main.order_pool +
      " </td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.invent_num + " </td><td>" +
      _params.main.invent_id +
      "</td><td> " + email_template.invent_name + " </td><td colspan=2>" +
      _params.main.invent_name +
      "</td><td> " + email_template.transmutation_name + " </td><td colspan=2>" +
      _params.main.variant_name +
      "</td> </tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.sales_price + " </td><td> " +
      _params.main.sales_price +
      " </td><td> " + email_template.currency + " </td><td> " +
      _params.main.currency_code +
      " </td><td> " + email_template.exch_rate + " </td><td> " +
      _params.main.exch_rate +
      " </td><td> " + email_template.order_qty + " </td><td> " +
      _params.main.sales_qty +
      "</td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.tax_group + " </td><td> " +
      _params.main.tax_group +
      " </td><td> " + email_template.order_delivery_date + " </td><td> " +
      _params.main.delivery_date +
      " </td><td> " + email_template.sales_company + " </td><td colspan=3 style='text-align:left'>" +
      _params.main.sales_company +
      "</td></tr></tr><tr><td>" + email_template.order_remark + "</td><td colspan=7 style='text-align:left'>" +
      _params.main.sales_description +
      "</td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=8></td></tr>"

    content +=
      "</table><table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'><tr style='font-family:黑体;font-size:14;text-align:center'><td> " +
      email_template.vend_num + " </td><td style='width: 260px;'> " + email_template.vend_name + " </td><td> " +
      email_template.dispatch_qty + " </td><td> " + email_template.dispatch_price + " </td><td> " + email_template.currency +
      " </td><td> " + email_template.vend_price + " </td><td> " + email_template.vend_cost + "</td><td> " +
      email_template.profit_rate + " （%）</td><td> " + email_template.exch_rate + " </td><td> " + email_template.tax_group + " </td><td> " +
      email_template.capacity + "</td><td> " + email_template.invent_sum + " </td><td> " + email_template.total_score +
      " </td><td> " + email_template.confirmed_dlv + " </td><td> " + email_template.dispatch_date + " </td></tr>"

    _.each(_params.items, t => {
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.vend_num + " </td>" //" + email_template.vend_num + "
      content += "<td> " + t.vend_name + " </td>" //" + email_template.vend_name + "
      content += "<td> " + t.qty + " </td>" //" + email_template.dispatch_qty + "
      content += "<td> " + t.price + " </td>" //" + email_template.dispatch_price + "
      content += "<td> " + t.currency_code + " </td>" //" + email_template.currency + "
      content += "<td> " + t.vend_price + " </td>" //" + email_template.vend_price + "
      content += "<td> " + t.cost_price + " </td>" //" + email_template.vend_cost + "
      content += "<td> " + t.price_rate + " </td>" //毛利率（%）
      content += "<td> " + t.exch_rate + " </td>" //" + email_template.exch_rate + "
      content += "<td> " + t.tax_group + " </td>" //销售" + email_template.tax_group + "
      content += "<td> " + t.capacity + " </td>" //" + email_template.capacity + "
      content += "<td> " + t.invent_sum + " </td>" //" + email_template.invent_sum + "
      content += "<td> " + t.total_score + " </td>" //" + email_template.total_score + "
      content += "<td> " + t.delivery_date + " </td>" //" + email_template.confirmed_dlv + "
      content += "<td> " + t.dispatch_date + " </td>" //" + email_template.dispatch_date + "
      content += "</tr>"
    })

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=4>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td><td colspan=11>" + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr></table><br/>"

    return sub_content + content
  },
  ///产能分配审批后模板
  getSODApprovedToOrderTemplate(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=3 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=6 style='text-align:center'></td></tr>"
    // " + email_template.approve_url + "：<a href='" +
    // _params.main.url +
    // "' rel='noopener' target='_blank'>" +
    // _params.main.url_name +
    // "</a>
    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_num + " </td><td> " +
      _params.main.order_code +
      " </td><td> " + email_template.customer_name + " </td><td colspan=3> " +
      _params.main.customer_name +
      " </td><td> " + email_template.order_pool + " </td><td colspan=2> " +
      _params.main.order_pool +
      " </td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.invent_num + " </td><td>" +
      _params.main.invent_id +
      "</td><td> " + email_template.invent_name + " </td><td colspan=2>" +
      _params.main.invent_name +
      "</td><td> " + email_template.transmutation_name + " </td><td colspan=3>" +
      _params.main.variant_name +
      "</td> </tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.sales_price + " </td><td> " +
      _params.main.sales_price +
      " </td><td> " + email_template.currency + " </td><td> " +
      _params.main.currency_code +
      " </td><td> " + email_template.exch_rate + " </td><td> " +
      _params.main.exch_rate +
      " </td><td> " + email_template.order_qty + " </td><td colspan=2> " +
      _params.main.sales_qty +
      "</td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.tax_group + " </td><td> " +
      _params.main.tax_group +
      " </td><td> " + email_template.order_delivery_date + " </td><td> " +
      _params.main.delivery_date +
      " </td><td> " + email_template.sales_company + " </td><td colspan=4 style='text-align:left'>" +
      _params.main.sales_company +
      "</td></tr></tr><tr><td>" + email_template.order_remark + "</td><td colspan=8 style='text-align:left'>" +
      _params.main.sales_description +
      "</td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=9></td></tr>"

    content +=
      "</table><table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'><tr style='font-family:黑体;font-size:14;text-align:center'><td> " +
      email_template.vend_num + " </td><td style='width: 260px;'> " + email_template.vend_name + " </td><td> " + email_template.dispatch_qty +
      " </td><td> " + email_template.currency + " </td><td> " + email_template.exch_rate + " </td><td> " + email_template.tax_group +
      " </td><td> " + email_template.capacity + "</td><td> " + email_template.invent_sum + " </td><td> " + email_template.total_score +
      " </td><td> " + email_template.confirmed_dlv + " </td><td> " + email_template.dispatch_date + " </td><td> " + email_template.apply_user +
      " </td></tr>"
    // <td> " + email_template.vend_price + " </td><td> " + email_template.vend_cost + "</td><td> " + email_template.profit_rate + " （%）</td>

    _.each(_params.items, t => {
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.vend_num + " </td>" //" + email_template.vend_num + "
      content += "<td> " + t.vend_name + " </td>" //" + email_template.vend_name + "
      content += "<td> " + t.qty + " </td>" //" + email_template.dispatch_qty + "
      // content += "<td> " + t.price + " </td>"; //" + email_template.dispatch_price + "
      content += "<td> " + t.currency_code + " </td>" //" + email_template.currency + "
      // content += "<td> " + t.vend_price + " </td>"; //" + email_template.vend_price + "
      // content += "<td> " + t.cost_price + " </td>"; //" + email_template.vend_cost + "
      // content += "<td> " + t.price_rate + " </td>"; //毛利率（%）
      content += "<td> " + t.exch_rate + " </td>" //" + email_template.exch_rate + "
      content += "<td> " + t.tax_group + " </td>" //销售" + email_template.tax_group + "
      content += "<td> " + t.capacity + " </td>" //" + email_template.capacity + "
      content += "<td> " + t.invent_sum + " </td>" //" + email_template.invent_sum + "
      content += "<td> " + t.total_score + " </td>" //" + email_template.total_score + "
      content += "<td> " + t.delivery_date + " </td>" //" + email_template.confirmed_dlv + "
      content += "<td> " + t.dispatch_date + " </td>" //" + email_template.dispatch_date + "
      content += "<td> " + t.create_by + " </td>" //" + email_template.apply_user + "
      content += "</tr>"
    })
    {/* <td colspan=4>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td> */}
    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=13>" + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr></table><br/>"

    return sub_content + content
  },
  ///产能分配审批后模板(仅供应商邮件通知人)
  getSalesOrderApprovedTemplateVend(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=3 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=6 style='text-align:center'>" + email_template.approve_url + "：<a href='" +
      _params.main.url +
      "' rel='noopener' target='_blank'>" +
      _params.main.url_name +
      "</a></td></tr>"
    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_num + " </td><td> " +
      _params.main.order_code +
      " </td><td> " + email_template.customer_name + " </td><td colspan=2> " +
      _params.main.customer_name +
      " </td><td> " + email_template.sales_company + " </td><td colspan=3> " +
      _params.main.sales_company +
      "</td></tr></tr><tr><td>" + email_template.order_remark + "</td><td colspan=8 style='text-align:left'>" +
      _params.main.sales_description +
      "</td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=9></td></tr>"

    content +=
      "</table><table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.vend_num + " </td><td style='width: 200px;'> " + email_template.vend_name + " </td><td> " + email_template.invent_num + " </td><td> " + email_template.invent_name + " </td><td> " + email_template.transmutation_name + " </td><td> " + email_template.dispatch_qty + " </td><td> " + email_template.dispatch_price + " </td><td> " + email_template.currency + " </td><td> " + email_template.exch_rate + " </td><td> " + email_template.tax_group + " </td><td> " + email_template.capacity + "</td><td> " + email_template.invent_sum + " </td><td> " + email_template.total_score + " </td><td> " + email_template.confirmed_dlv + " </td><td> " + email_template.dispatch_date + " </td><td> " + email_template.apply_user + " </td></tr>"
    // <td> " + email_template.vend_price + " </td><td> " + email_template.vend_cost + "</td><td> " + email_template.profit_rate + " （%）</td>

    _.each(_params.items, t => {
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.vend_num + " </td>" //" + email_template.vend_num + "
      content += "<td> " + t.vend_name + " </td>" //" + email_template.vend_name + "
      content += "<td> " + _params.main.invent_id + " </td>" //" + email_template.invent_num + "
      content += "<td> " + _params.main.invent_name + " </td>" //" + email_template.invent_name + "
      content += "<td> " + _params.main.variant_name + " </td>" //" + email_template.transmutation_name + "
      content += "<td> " + t.qty + " </td>" //" + email_template.dispatch_qty + "
      content += "<td> " + t.price + " </td>" //" + email_template.dispatch_price + "
      content += "<td> " + t.currency_code + " </td>" //" + email_template.currency + "
      content += "<td> " + t.exch_rate + " </td>" //" + email_template.exch_rate + "
      content += "<td> " + t.tax_group + " </td>" //销售" + email_template.tax_group + "
      content += "<td> " + t.capacity + " </td>" //" + email_template.capacity + "
      content += "<td> " + t.invent_sum + " </td>" //" + email_template.invent_sum + "
      content += "<td> " + t.total_score + " </td>" //" + email_template.total_score + "
      content += "<td> " + t.delivery_date + " </td>" //" + email_template.confirmed_dlv + "
      content += "<td> " + t.dispatch_date + " </td>" //" + email_template.dispatch_date + "
      content += "<td> " + t.create_by + " </td>" //派发创建人
      content += "</tr>"
    })
    {/* <td colspan=4>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td> */}
    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=16>" + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr></table><br/>"

    return sub_content + content
  },

  ///预测订单模板
  getForcastTemplate(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0'  style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'><tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=2 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=7 style='text-align:center'>" + email_template.approve_url + "：<a href='" +
      _params.main.url +
      "' rel='noopener' target='_blank'>" +
      _params.main.url_name +
      "</a></td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.forecast_order_num + " </td><td> " +
      _params.main.forcast_code +
      "  </td><td> " + email_template.customer_name + " </td><td colspan=2> " +
      _params.main.customer_name +
      " </td><td> " + email_template.sales_company + " </td><td colspan=3> 	" +
      _params.main.sales_company +
      " </td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=4>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td><td colspan=5>" + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr></table>"

    return sub_content + content
  },

  ///预测派发模板
  getForcastDispatchTemplate(_params, vm) {
    let lang_code = this.getUserLangCode(vm, _params.email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let sub_content = ""
    if (_params.sub_content) {
      sub_content = _params.sub_content
    }
    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'><tr style='font-family:黑体;font-size:24;text-align:center'><td colspan=3 style='text-align:center'>" +
      _params.main.type_name +
      "</td><td colspan=5 style='text-align:center'>" + email_template.approve_url + "：<a href='" +
      _params.main.url +
      "' rel='noopener' target='_blank'>" +
      _params.main.url_name +
      "</a></td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.forecast_order_num + " </td><td> " +
      _params.main.forcast_code +
      " </td><td> " + email_template.customer_name + " </td><td colspan=3> " +
      _params.main.customer_name +
      " </td><td> " + email_template.forecast_modal + " </td><td> " +
      _params.main.model_id +
      " </td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.invent_num + " </td><td>" +
      _params.main.invent_id +
      "</td><td> " + email_template.invent_name + " </td><td colspan=2>" +
      _params.main.invent_name +
      "</td><td> " + email_template.transmutation_name + " </td><td colspan=2>" +
      _params.main.variant_name +
      "</td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.order_qty + " </td><td> " +
      _params.main.sales_qty +
      "</td><td> " + email_template.forecast_accuracy + "（%） </td><td> " +
      _params.main.forcast_rate +
      " </td><td> " + email_template.forecast_modal + " </td><td> " +
      _params.main.forcast_type +
      "</td><td> " + email_template.confirmed_dlv + " </td><td> " +
      _params.main.delivery_date +
      " </td></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td> " + email_template.sales_company + " </td><td colspan=3 style='text-align:left'>" +
      _params.main.sales_company +
      " </td><td> " + email_template.forecast_remark + "</td><td colspan=3 style='text-align:left'>" +
      _params.main.forcast_description +
      "</td></tr></tr><tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=8></td></tr></table>"

    content += "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'><tr style='font-family:黑体;font-size:14;text-align:center'><td> " +
      email_template.vend_num + " </td><td style='width: 260px;'> " + email_template.vend_name + " </td><td> " + email_template.dispatch_qty +
      " </td><td> " + email_template.capacity + " </td><td> " + email_template.vend_score + " </td><td> " + email_template.confirmed_dlv +
      " </td><td colspan=2> " + email_template.remark + " </td></tr>"

    _.each(_params.items, t => {
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.vend_num + " </td>"
      content += "<td> " + t.vend_name + " </td>"
      content += "<td> " + t.qty + " </td>"
      content += "<td> " + t.capacity + " </td>"
      content += "<td> " + t.total_score + " </td>"
      content += "<td> " + t.delivery_date + " </td>"
      content += "<td colspan=2> " + t.dispatch_description + " </td>"
      content += "</tr>"
    })

    content +=
      "<tr style='font-family:黑体;font-size:14;text-align:center'><td colspan=4>" + email_template.apply_user + "：" +
      _params.main.username +
      "</td><td colspan=4>" + email_template.apply_date + "：" +
      _params.main.create_at +
      "</td></tr></table><br/>"

    return sub_content + content
  },

  ///审批后通知邮件模板
  getApprovedEmailTemplate(_params, vm, type, is_refused) {
    let lang_code = this.getUserLangCode(vm, _params.create_by_username)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let notify_list = []
    let _send_to = {}
    _send_to[_params.create_by_username] = ""
    let _subject = _params.subject + email_template.approved + "，" + email_template.care_receive + "！"
    if (is_refused) {
      _subject = _params.subject + email_template.approve_return + "，" + email_template.care_receive + "！"
    }
    if (_params.notify_type == "so_email_to_purch") {
      _subject = _params.subject + "，" + email_template.care_receive + "！"
    }
    let _notify_p = {
      category: _params.notify_type, //如：so_approve_pass
      idx: "",
      itemId: 0,
      notify_type: _params.notify_type, //如：so_approve_pass
      subject: _subject,
      content: "",
      SendTo: _send_to
    }
    console.log(_params.list)
    _.each(_params.list, t => {
      if (!_.includes(notify_list, t[_params.idx])) {
        notify_list.push(t[_params.idx])
      }
    })
    if (notify_list.length > 0) {
      let context_key = ""
      let context_context = ""
      if (
        _params.notify_type == "so_approve_pass" ||
        _params.notify_type == "credit_approve_pass" ||
        _params.notify_type == "price_approve_pass"
      ) {
        context_key = "SalesId"
        context_context += methods.getSOApprovedEmailTemplate(_params.list, vm, _params.create_by_username)
      } else if (_params.notify_type == "so_email_to_purch") {
        context_key = "SalesId"
        context_context += methods.getSOToPurchEmailTemplate(_params.list, vm, _params.create_by_username)
      }
      else if (_params.notify_type == "sf_approve_pass") {
        context_key = "ForecastSalesId"
        context_context += methods.getSFApprovedEmailTemplate(_params.list, vm, _params.create_by_username)
      } else if (_params.notify_type == "sod_approve_pass") {
        context_key = "SalesId"
        context_context += methods.getSODApprovedEmailTemplate(_params.list, vm, type, _params.create_by_username)
      } else if (_params.notify_type == "sfd_approve_pass") {
        context_key = "ForecastSalesId"
        context_context += methods.getSFDApprovedEmailTemplate(_params.list, _params.orderline, vm, _params.create_by_username)
      }
      let context_list = []
      _.each(_params.list, t => {
        if (!_.includes(context_list, t[context_key])) {
          context_list.push(t[context_key])
        }
      })
      _notify_p.content = _.join(context_list, "，") + "，" + email_template.approved + "！"
      if (is_refused) {
        _notify_p.content = _.join(context_list, "，") + "，" + email_template.approve_return + "！"
      }
      if (_params.notify_type == "so_email_to_purch") {
        _notify_p.content = _.join(context_list, "，") + email_template.created + "！"
      }
      _notify_p.content += context_context
      return _notify_p
    } else {
      return null
    }
  },

  ///销售订单审批后邮件模板
  getSOApprovedEmailTemplate(list, vm, email_user) {
    let lang_code = this.getUserLangCode(vm, email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-weight:bold;font-size:16;text-align:center'>"
    content += "<td> " + email_template.order_num + " </td>"
    content += "<td style='width: 260px;'> " + email_template.customer_name + " </td>"
    content += "<td> " + email_template.order_pool + " </td>"
    content += "<td> " + email_template.order_amount + " </td>"
    content += "<td> " + email_template.currency + " </td>"
    content += "<td> " + email_template.exch_rate + " </td>"
    content += "<td> " + email_template.tax_group + " </td>"
    content += "<td> " + email_template.customer_credit + " </td>"
    content += "<td> " + email_template.valid_credit + " </td>"
    content += "<td> " + email_template.order_remark + " </td>"
    content += "</tr>"
    _.each(list, t => {
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.SalesId + " </td>"
      content += "<td> " + t.SalesName + " </td>"
      content += "<td> " + t.SalesPoolId + " </td>"
      content += "<td> " + numbro(t.OrderAmountWOTax).format({ thousandSeparated: true, mantissa: 2 }) + " </td>"
      content += "<td> " + t.CurrencyCode + " </td>"
      content += "<td> " + t.ExchRate + " </td>"
      content += "<td> " + t.TaxGroup + " </td>"
      content += "<td> " + numbro(t.CreditMax + t.Temp_CreditMax).format({ thousandSeparated: true, mantissa: 2 }) + " </td>"
      content += "<td> " + numbro(t.CreditMax + t.Temp_CreditMax - t.dispUsedCreditAmount - t.CustomerNotDispatchAmt).format({ thousandSeparated: true, mantissa: 2 }) + " </td>"
      content += "<td> " + _.isNull(t.TEC_Remark) ? "" : t.TEC_Remark + " </td>"
      content += "</tr>"
      if (t.children && t.children.length > 0) {
        content +=
          "<tr><td colspan=10 style='padding:2px 0px'><table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:60%;margin:0;'>"
        content +=
          "<tr style='font-family:黑体;font-weight:bold;font-size:12;text-align:center'>"
        content += "<td style='width: 100px;'> " + email_template.invent_num + " </td>"
        content += "<td style='width: 260px;'> " + email_template.invent_name + " </td>"
        content += "<td style='width: 100px;'> " + email_template.order_qty + " </td>"
        content += "</tr>"
        _.each(t.children, ct => {
          content +=
            "<tr style='font-family:黑体;font-size:12;text-align:center'>"
          content += "<td> " + ct.invent_num + " </td>"
          content += "<td> " + ct.invent_name + " </td>"
          content += "<td> " + ct.sales_qty + " </td>"
          content += "</tr>"
        })
        content += "</table></td></tr>"
      }
    })

    content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
    content += "<td colspan=5>" + email_template.approver + "：" + vm.$global.global_data.local_username + "</td>"
    content += "<td colspan=5>" + email_template.approve_date + "：" + vm.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "</td>"
    content += "</tr></table><br/>"
    return content
  },
  //发邮件给采购邮件通知人
  getSOToPurchEmailTemplate(list, vm, email_user) {
    let lang_code = this.getUserLangCode(vm, email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-weight:bold;font-size:16;text-align:center'>"
    content += "<td> " + email_template.order_num + " </td>"
    content += "<td style='width: 260px;'> " + email_template.customer_name + " </td>"
    content += "<td> " + email_template.order_pool + " </td>"
    // content += "<td> " + email_template.order_amount + " </td>";
    content += "<td> " + email_template.currency + " </td>"
    content += "<td> " + email_template.exch_rate + " </td>"
    content += "<td> " + email_template.tax_group + " </td>"
    // content += "<td> " + email_template.customer_credit + " </td>";
    // content += "<td> " + email_template.valid_credit + " </td>";
    content += "<td> " + email_template.order_remark + " </td>"
    content += "</tr>"
    _.each(list, t => {
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.SalesId + " </td>"
      content += "<td> " + t.SalesName + " </td>"
      content += "<td> " + t.SalesPoolId + " </td>"
      // content +=
      //   "<td> " +
      //   numbro(t.OrderAmountWOTax).format({
      //     thousandSeparated: true,
      //     mantissa: 2
      //   }) +
      //   " </td>";
      content += "<td> " + t.CurrencyCode + " </td>"
      content += "<td> " + t.ExchRate + " </td>"
      content += "<td> " + t.TaxGroup + " </td>"
      // content +=
      //   "<td> " +
      //   numbro(t.CreditMax + t.Temp_CreditMax).format({
      //     thousandSeparated: true,
      //     mantissa: 2
      //   }) +
      //   " </td>";
      // content +=
      //   "<td> " +
      //   numbro(
      //     t.CreditMax +
      //     t.Temp_CreditMax -
      //     t.dispUsedCreditAmount -
      //     t.CustomerNotDispatchAmt
      //   ).format({
      //     thousandSeparated: true,
      //     mantissa: 2
      //   }) +
      //   " </td>";
      content +=
        "<td> " + _.isNull(t.TEC_Remark) ? "" : t.TEC_Remark + " </td>"
      content += "</tr>"
      if (t.children && t.children.length > 0) {
        content +=
          "<tr><td colspan=7 style='padding:2px 0px'><table border='1' solid black cellpadding='7' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:60%;margin:0;'>"
        content +=
          "<tr style='font-family:黑体;font-weight:bold;font-size:12;text-align:center'>"
        content += "<td style='width: 100px;'> " + email_template.invent_num + " </td>"
        content += "<td style='width: 260px;'> " + email_template.invent_name + " </td>"
        content += "<td style='width: 100px;'> " + email_template.order_qty + " </td>"
        content += "</tr>"
        _.each(t.children, ct => {
          content += "<tr style='font-family:黑体;font-size:12;text-align:center'>"
          content += "<td> " + ct.invent_num + " </td>"
          content += "<td> " + ct.invent_name + " </td>"
          content += "<td> " + ct.sales_qty + " </td>"
          content += "</tr>"
        })
        content += "</table></td></tr>"
      }
    })

    content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
    // content +=
    //   "<td colspan=5>" + email_template.approver + "：" +
    //   vm.$global.global_data.local_username +
    //   "</td>";
    content += "<td colspan=7>" + email_template.date_time + "：" + vm.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "</td>"
    content += "</tr></table><br/>"
    return content
  },

  ///销售订单审批后邮件模板
  getSODApprovedEmailTemplate(list, vm, type, email_user) {
    let lang_code = this.getUserLangCode(vm, email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let _content = ""
    let group_sfl_list = _.groupBy(list, "SalesLineId")
    for (var i in group_sfl_list) {
      let order_line_m = group_sfl_list[i][0]
      console.log(group_sfl_list[i])
      let _params = {}

      let company_name = ""
      let _company_m = _.find(vm.$store.state.biz_data.baseData.CompanyInfo, {
        DataArea: order_line_m.dataAreaId
      })
      if (_company_m) {
        company_name = _company_m.CompanyName
      }
      _params.main = {
        type_name: "" + email_template.so_approve + "",
        url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch?k=" + order_line_m.SalesId,
        url_name: window.location.host + "/sd/saleOrderDispatch?k=" + order_line_m.SalesId,
        order_code: order_line_m.SalesId,
        customer_name: order_line_m.SalesName,
        order_pool: order_line_m.SalesPoolId,
        invent_id: order_line_m.ItemId,
        invent_name: order_line_m.NameAlias,
        variant_name: order_line_m.VariantName,
        sales_price: order_line_m.SalesPrice,
        currency_code: order_line_m.CurrencyCode,
        exch_rate: order_line_m.ExchRate,
        sales_qty: order_line_m.SalesQty,
        tax_group: order_line_m.TaxGroup,
        delivery_date: commonController.formatDate(order_line_m.ConfirmedDlv),
        sales_company: company_name,
        sales_description: order_line_m.TEC_CommonRemark,
        username: vm.$global.global_data.local_username,
        create_at: vm.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
      }
      _params.email_user = email_user
      _params.items = []
      _.each(group_sfl_list[i], t => {
        _params.items.push({
          vend_num: t.AccountNum,
          vend_name: t.SEI_Name,
          qty: t.qty,
          price: t.price_wotax,
          currency_code: t.PurchCurrencyCode,
          cost_price: t.Cost_Sum,
          price_rate: t.Sales_Order_Price == 0 ? "-100%" : numbro(((t.Sales_Order_Price - t.price_wotax) / t.Sales_Order_Price) * 100).format({ thousandSeparated: true, mantissa: 2 }),
          vend_price: t.price_vend_wotax,
          exch_rate: order_line_m.ExchRate,
          tax_group: order_line_m.TaxGroup,
          capacity: t.Capacity,
          invent_sum: t.invent_sum,
          total_score: t.TotalScore,
          delivery_date: commonController.formatDate(t.delivery_date),
          dispatch_date: commonController.formatDate(t.create_at),
          create_by: t.create_by_username
        })
      })
      if (type == "vend") {
        _content += methods.getSalesOrderApprovedTemplateVend(_params, vm)
      } else {
        _content += methods.getSODApprovedToOrderTemplate(_params, vm)
      }
    }
    return _content
  },

  ///预测订单审批后邮件模板表格
  getSFApprovedEmailTemplate(list, vm, email_user) {
    let lang_code = this.getUserLangCode(vm, email_user)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let content =
      "<table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:100%;margin:0;'>"
    content +=
      "<tr style='font-family:黑体;font-weight:bold;font-size:16;text-align:center'>"
    content += "<td> " + email_template.forecast_order_num + " </td>"
    content += "<td style='width: 260px;'> " + email_template.customer_name + " </td>"
    content += "<td> " + email_template.sales_company + " </td>"
    content += "<td> " + email_template.order_remark + " </td>"
    content += "</tr>"
    _.each(list, t => {
      let company_name = ""
      let _company_m = _.find(vm.$store.state.biz_data.baseData.CompanyInfo, {
        DataArea: t.dataAreaId
      })
      if (_company_m) {
        company_name = _company_m.CompanyName
      }
      content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
      content += "<td> " + t.ForecastSalesId + " </td>"
      content += "<td> " + t.CustAccountName + " </td>"
      content += "<td> " + company_name + " </td>"
      content += "<td> " + _.isNull(t.description) ? " " : t.description + " </td>"
      content += "</tr>"
      if (t.children && t.children.length > 0) {
        content +=
          "<tr><td colspan=4 style='padding:2px 0px'><table border='1' solid black cellpadding='10' text-align='center' cellspacing='0' style='border-collapse: collapse;table-layout:fixed;width:60%;margin:0;'>"
        content +=
          "<tr style='font-family:黑体;font-weight:bold;font-size:12;text-align:center'>"
        content += "<td> " + email_template.invent_num + " </td>"
        content += "<td style='width: 260px;'> " + email_template.invent_name + " </td>"
        content += "<td> " + email_template.order_qty + " </td>"
        content += "</tr>"
        _.each(t.children, ct => {
          content +=
            "<tr style='font-family:黑体;font-size:12;text-align:center'>"
          content += "<td> " + ct.invent_num + " </td>"
          content += "<td> " + ct.invent_name + " </td>"
          content += "<td> " + ct.sales_qty + " </td>"
          // content += "<td></td>";
          content += "</tr>"
        })
        content += "</table></td></tr>"
      }
    })

    content += "<tr style='font-family:黑体;font-size:14;text-align:center'>"
    content += "<td colspan=2>" + email_template.approver + "：" + vm.$global.global_data.local_username + "</td>"
    content += "<td colspan=2>" + email_template.approve_date + "：" + vm.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "</td>"
    content += "</tr></table><br/>"
    return content
  },
  ///预测订单审批后邮件模板
  getSFDApprovedEmailTemplate(list, orderline, vm, Approver) {
    let lang_code = this.getUserLangCode(vm, Approver)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let _content = ""
    let _params = {}
    let group_sfl_list = _.groupBy(list, "OrderForecast_Line_id")
    for (var i in group_sfl_list) {
      let order_line_m = group_sfl_list[i][0]
      if (orderline) {
        order_line_m = orderline
      }
      let company_name = ""
      let _company_m = _.find(vm.$store.state.biz_data.baseData.CompanyInfo, {
        DataArea: order_line_m.dataAreaId
      })
      if (_company_m) {
        company_name = _company_m.CompanyName
      }
      _params.main = {
        type_name: "" + email_template.sf_approve + "",
        url: window.location.protocol + "//" + window.location.host + "/sd/OrderForecastDispatch?k=" + order_line_m.ForecastSalesId,
        url_name: window.location.host + "/sd/OrderForecastDispatch?k=" + order_line_m.ForecastSalesId,
        forcast_code: order_line_m.ForecastSalesId,
        customer_name: order_line_m.CustAccountName,
        model_id: order_line_m.ModelId,
        invent_id: order_line_m.ItemId,
        invent_name: order_line_m.NameAlias,
        variant_name: order_line_m.VariantName,
        sales_qty: order_line_m.SalesQty,
        forcast_rate: order_line_m.SEI_ForecastAccuracy,
        forcast_type: order_line_m.SEI_ForecastSalesType,
        delivery_date: commonController.formatDate(order_line_m.StartDate),
        sales_company: company_name,
        forcast_description: _.isNull(order_line_m.description) ? "" : order_line_m.description,
        username: vm.$global.global_data.local_username,
        create_at: vm.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
      }
      _params.email_user = Approver
      _params.items = []
      _.each(group_sfl_list[i], t => {
        _params.items.push({
          vend_num: t.AccountNum,
          vend_name: t.SEI_Name,
          qty: t.qty,
          capacity: t.Capacity,
          total_score: t.TotalScore,
          delivery_date: commonController.formatDate(t.delivery_date),
          dispatch_description: ""
        })
      })
      _content += methods.getForcastDispatchTemplate(_params, vm)
    }
    return _content
  },
  // =====================
  //#region 获取模板
  getTemplate(vm, temp_code, data, Approver) {
    let lang_code = this.getUserLangCode(vm, Approver)
    let email_template = vm.$getAloneLanguageAsync(lang_code, "email_template")

    let templates = vm.$store.state.biz_data.templateData.templates
    let source = ""
    if (templates) {
      let m = _.find(templates, { notify_type: temp_code })
      if (m) {
        source = m.content
        data.main.Title = email_template[temp_code] + "-" + _date.format(new Date(), "yyyy-MM-dd")
        data.fields = {
          approve_url: email_template.approve_url,
          invent_num: email_template.invent_num,
          invent_name: email_template.invent_name,
          vend_name: email_template.vend_name,
          initail_price: email_template.initail_price,
          purch_price: email_template.purch_price,
          price_remark: email_template.price_remark,
          real_sales_price: email_template.real_sales_price,
          dispatch_qty: email_template.dispatch_qty,
          dispatch_amount: email_template.dispatch_amount,
          dispatch_profit_rate: email_template.dispatch_profit_rate,
          quote_profit_rate: email_template.quote_profit_rate,
          remark: email_template.remark,
          dispatch_user: email_template.dispatch_user,
          dispatch_date: email_template.dispatch_date,
          DistributionRateChangedDes: email_template.DistributionRateChangedDes
        }
      }
    }

    var fn = template.compile(source)
    var temp_html = ""
    temp_html = fn(data)
    // console.log(temp_html);
    return temp_html
  }
  //#endregion
}

export { itemForm, mainForm, methods }

